var app = angular.module('directives.cvvKeyboard', []);

    require('./directives/cvv.js');
    require('./stylesheets/styles.scss');

module.exports = app;



/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/cvvKeyboard/index.js
 ** module id = 159
 ** module chunks = 1
 **/